// extracted by mini-css-extract-plugin
export default {"menuCoupon":"MenuCoupon_menuCoupon__vlD+J","text":"MenuCoupon_text__YHAhw","subtext":"MenuCoupon_subtext__jqMvM"};